import { Theme, Components } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  defaultProps: {
    popupIcon: <ExpandMoreIcon />,
  },
  styleOverrides: {
    root: ({ ownerState }) => {
      const isSmall = ownerState.size === 'small';
      const isMultiple = ownerState.multiple === true;

      return {
        '& .MuiInputBase-root': {
          paddingBlock: '0 !important',
          ...(isMultiple && {
            height: 'unset',
            minHeight: isSmall ? '34px' : '44px',
          }),
          '& .MuiInputBase-input': {
            padding: '0 !important',
            ...(isMultiple && {
              height: 'unset',
              minHeight: isSmall ? '34px' : '44px',
            }),
          },
        },
      };
    },
    // Dropdown popup text follows the field size: small → body2.
    // The paper wraps the listbox, options and the loading/no-options text,
    // so the font-size cascades to all of them.
    paper: ({ ownerState, theme }) =>
      ownerState.size === 'small' ? { ...theme.typography.body2 } : {},
  },
};
